module.exports = __webpack_public_path__ + "static/media/fly0068.924b5d3e.webp";